/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateBankAccountSuffixToFourDigits} from '../api'

export const useMutationUpdateBankAccountSuffixToFourDigits = createReactQueryMutationHook('updateBankAccountSuffixToFourDigits', updateBankAccountSuffixToFourDigits)
